import React, { useContext } from 'react';
import { NavigationDots, SocialMedia } from '../components';
import { ThemeContext } from '../ThemeContext';

const AppWrap = (Component, idName, classNames) =>
  function HOC() {
    const { darkMode } = useContext(ThemeContext);

    return (
      <div
        id={idName}
        className={`app__container 
            ${
              darkMode === true
                ? classNames === 'app__whitebg'
                  ? 'app__darkGraybg'
                  : 'app__secondarybg'
                : classNames
            }`}
      >
        <SocialMedia />
        <div className="app__wrapper app__flex">
          <Component />

          <div className={darkMode === true ? 'copyright-true' : 'copyright'}>
            <p>Handcrafted by me © 2022</p>
            <p>Made with Framer Motion</p>
          </div>
        </div>
        <NavigationDots active={idName} />
      </div>
    );
  };

export default AppWrap;
